import { transformSanityResources } from '@/services/adapters/transformations/transformSanityResources'
import {
  ISanityTip,
  transformSanityTips
} from '@/services/adapters/transformations/transformSanityTips'

export const transformSanityEffect = (
  effect: any,
  disableValidations: boolean
) => {
  if (effect.tips) {
    effect.tips = transformSanityTips(
      effect.tips as ISanityTip[],
      disableValidations
    )
  }
  if (effect.resources) {
    effect.resources = transformSanityResources(
      effect.resources,
      disableValidations
    )
  }
  return effect
}
